module.exports = __webpack_public_path__ + "static/applebadge-536dcde503a96e678cd1f09f5bc4a32c.svg";